import {Subject} from 'rxjs'
import {debounceTime, distinctUntilChanged} from 'rxjs/operators'

const typpingPipe = new Subject().pipe(
  debounceTime(1000),
  distinctUntilChanged()
)

let typpingPipeSubscription = undefined

export const debounce = (value, callback) => {
  if (!typpingPipeSubscription) {
    typpingPipeSubscription = typpingPipe.subscribe(v => {
      if (typpingPipeSubscription) {
        typpingPipeSubscription.unsubscribe()
        typpingPipeSubscription = undefined
        callback(v)
      }
    })
  }
  typpingPipe.next(value)
}
